import routes from '@modules/academy/academy-routes';
import store from '@modules/academy/academy-store';

export default {
  routes,
  store,
};
